// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import DocumentModeCanvasColumnDebugger from './DocumentModeCanvasColumnDebugger';
import DocumentModeCanvasReadingLineDebugger from './DocumentModeCanvasReadingLineDebugger';

const DocumentModeCanvasClusterDebugger = ({ gridSize, clusterIndex, clusterData, elementOrder }) => {
    const columnReadingLines = clusterData.get('readingData');
    const columnsData = clusterData.get('children');

    return (
        <div className="DocumentModeCanvasClusterDebugger">
            {columnsData.map((columnClusterData, index) => (
                <DocumentModeCanvasColumnDebugger
                    key={index}
                    gridSize={gridSize}
                    clusterIndex={clusterIndex}
                    columnIndex={index + 1}
                    columnData={columnClusterData}
                    elementOrder={elementOrder}
                />
            ))}
            {columnReadingLines.map((readingLine, index) => (
                <DocumentModeCanvasReadingLineDebugger
                    className="column"
                    key={index}
                    gridSize={gridSize}
                    order={index + 1}
                    {...readingLine.toJS()}
                />
            ))}
        </div>
    );
};

DocumentModeCanvasClusterDebugger.propTypes = {
    gridSize: PropTypes.number.isRequired,
    clusterIndex: PropTypes.number.isRequired,
    clusterData: PropTypes.object.isRequired,
    elementOrder: PropTypes.object.isRequired,
};

export default DocumentModeCanvasClusterDebugger;
